export class MemberBackgroundData {
    public id: string = "0";
    public member_id: string;
    public member_name: string;
    public dateStart: Date;
    public dateEnd: Date;
    public location: string;
    public text: string;   

    constructor() {}
}